import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from "rxjs/operators";
import { Router } from '@angular/router';
import { UserService } from '../../services/user.service';

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {

  constructor(
    private readonly router: Router,
    private readonly userService: UserService 
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap(
        event => { },
        error => {
          if (error instanceof HttpErrorResponse) {
            // Add more if blocks for other error codes as needed
            if (error.status === 403) {
              this.userService.getCurrentUser().subscribe({
                complete: () => window.location.reload()
              });
            }
            if (error.status === 418) {
              //TODO: I'm a Teapot
            }
          }
        }
    ));
  }
}
